export default __webpack_public_path__ + "static/media/chris.5da7f7f2.png";